import { Paper, Grid2 as Grid, Select, MenuItem, styled, Button } from "@mui/material";
import moment from "moment";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DateTimeRangeSelect from "../../components/input/date/DateTimeRangeSelect";
import FormInput from "../../components/input/form/FormInput";
import { StateAction } from "../../utils/typeAlias";
import IEmployee from "../../models/employee";
import { IPropertyGroup } from "../../models/propertyGroup";
import { IRoute } from "../../models/route";

const CenterGrid = styled(Grid)(() => ({
    display: "flex",
    alignItems: "center",
}));
interface SearchProps {
    propertyGroups: IPropertyGroup[];
    setPropertyGroupId: StateAction<number>;
    propertyGroupId: number;
    start: Date;
    setStart: StateAction<Date>;
    end: Date | undefined;
    setEnd: StateAction<Date | undefined>;
    selectedEmployees: number[];
    setSelectedEmployees: StateAction<number[]>;
    employees: IEmployee[];
    isFilteredByRoute?: boolean;
    routes?: IRoute[];
    selectedRoutes?: number[];
    setSelectedRoutes?: StateAction<number[]>;
}

const SearchBarPropertyGroups = ({
    start,
    setStart,
    end,
    setEnd,
    propertyGroups,
    propertyGroupId,
    setPropertyGroupId,
    selectedEmployees,
    setSelectedEmployees,
    employees,
    isFilteredByRoute = false,
    selectedRoutes,
    setSelectedRoutes,
    routes

}: SearchProps) => {
    const { t } = useTranslation();
    const [selectedStart, setSelectedStart] = useState<Date>(start)
    const [selectedEnd, setSelectedEnd] = useState<Date | undefined>(end)
    const [selectedPGroupId, setSelectedPGroupId] = useState<number>(propertyGroupId)

    useEffect(() => {
        setSelectedPGroupId(propertyGroupId)
    }, [propertyGroupId])

    const onRefreshFilter = () => {
        setStart(selectedStart)
        setEnd(selectedEnd)
        setPropertyGroupId(selectedPGroupId)
    }

    const updateEmployee = (value: string | number[]): void => {
        const ids =
            typeof value === "string"
                ? value.split(",").map((v) => Number(v))
                : value;
        setSelectedEmployees(ids);
    };

    const updateRoutes = (value: string | number[]): void => {
        const ids =
            typeof value === "string"
                ? value.split(",").map((v) => Number(v))
                : value;
        setSelectedRoutes && setSelectedRoutes(ids);
    };
    return (
        <Paper elevation={1} sx={{ padding: 2 }}>
            <Grid container display={"flex"} justifyContent="space-around" rowSpacing={2} columnSpacing={{ xs: 2, md: 0 }}>
                <Grid size={{ xs: 12, sm: 5, md: 3 }}>
                    <DateTimeRangeSelect
                        minDate={moment("2023-01-01").startOf("day").toDate()}
                        sameDaySelection
                        disableFuture
                        start={selectedStart}
                        setStart={setSelectedStart}
                        end={selectedEnd}
                        setEnd={setSelectedEnd}
                        labelName={""}
                    />
                </Grid>

                <CenterGrid size={{ xs: 12, sm: 5, md: 3 }}>
                    <FormInput
                        sx={{ width: "100%" }}
                        label={t("table.property.propertyGroups")}
                    >
                        <Select
                            notched
                            fullWidth
                            defaultValue={-1}
                            value={selectedPGroupId}
                            onChange={(event) =>
                                setSelectedPGroupId(Number(event.target.value))
                            }
                            id="building-select"
                        >
                            {propertyGroups.map((propertyGroup) => (
                                <MenuItem
                                    key={`building_${propertyGroup.id}`}
                                    value={propertyGroup.id}
                                >
                                    {propertyGroup.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormInput>
                </CenterGrid>

                {isFilteredByRoute && (<CenterGrid size={{ xs: 12, sm: 5, md: 2 }}>
                    <FormInput
                        sx={{ width: "100%" }}
                        label="Route"
                    >
                        <Select
                            notched
                            multiple
                            fullWidth
                            disabled={employees.length <= 0}
                            defaultValue={[-1]}
                            value={selectedRoutes}
                            onChange={(event) =>
                                updateRoutes(event.target.value)
                            }
                            id="route-select"
                        >
                            {routes && routes.map((route) => (
                                <MenuItem
                                    key={`route_${route.id}`}
                                    value={route.id}
                                >
                                    {route.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormInput>


                </CenterGrid>
                )}

                <CenterGrid size={{ xs: 12, sm: 5, md: 3 }}>
                    <FormInput
                        sx={{ width: "100%" }}
                        label={t("header.employee")}
                    >
                        <Select
                            fullWidth
                            multiple
                            notched
                            disabled={employees.length <= 0}
                            defaultValue={[-1]}
                            value={selectedEmployees}
                            onChange={(event) =>
                                updateEmployee(event.target.value)
                            }
                            labelId="floor-label"
                            id="floor-select"
                        >
                            {employees.map((employee) => (
                                <MenuItem
                                    key={`user_${employee.id}`}
                                    value={employee.id}
                                >
                                    {employee.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormInput>
                </CenterGrid>

                <Grid size={{ xs: 12, sm: 5, md: 4 }} offset={{ md: 'auto' }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={
                            selectedStart.toString() == start.toString() && selectedEnd?.toString() == end?.toString() && selectedPGroupId == propertyGroupId
                        }
                        sx={{
                            marginRight: "1em",
                        }}
                        onClick={() => onRefreshFilter()}
                    >
                        {t("header.applyFilters")}
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default SearchBarPropertyGroups;
